import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanningProfileLookup extends Layout {
    sourceBrokeragePlanningProfile: DataSource;
    tableLookup: Table;
}
